// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3VfIO","icon":"SortAdornment_icon__2rSGD","up":"SortAdornment_up__4K22A","down":"SortAdornment_down__219cF","active":"SortAdornment_active__gsWC9"};